import { Component } from '@angular/core';

@Component({
  selector: 'app-svg-delivery-error',
  templateUrl: './delivery-error.component.html'
})
export class DeliveryErrorComponent {}
